/** 基础组件 + 业务组件路由（主路由与分享构建共用） */
export const foundationBusinessRoutes = [
  {
    path: '/business',
    name: 'Business',
    component: () => import('../views/Business.vue'),
  },
  {
    path: '/business/standard-dialogs',
    name: 'BusinessStandardDialogs',
    component: () => import('../business-views/StandardBusinessDialogsView.vue')
  },
  {
    path: '/business/confirm-prompt',
    name: 'BusinessConfirmPrompt',
    redirect: () => ({ path: '/business/standard-dialogs', hash: '#biz-confirm-prompt' })
  },
  {
    path: '/business/form-settings',
    name: 'BusinessFormSettings',
    redirect: () => ({ path: '/business/standard-dialogs', hash: '#biz-form-settings' })
  },
  {
    path: '/business/data-entry',
    name: 'BusinessDataEntry',
    redirect: () => ({ path: '/business/standard-dialogs', hash: '#biz-issue-record' })
  },
  {
    path: '/business/table-operations',
    name: 'BusinessTableOperations',
    redirect: () => ({ path: '/business/standard-dialogs', hash: '#biz-table-operations' })
  },
  {
    path: '/business/panels',
    name: 'BusinessPanels',
    redirect: () => ({ path: '/business/standard-dialogs', hash: '#biz-panels' })
  },
  {
    path: '/business/complex-dialogs',
    name: 'BusinessComplexDialogs',
    redirect: () => ({ path: '/business/standard-dialogs', hash: '#biz-complex-dialogs' })
  },
  {
    path: '/business/standard-navigation',
    name: 'BusinessStandardNavigation',
    component: () => import('../business-views/StandardNavigationView.vue')
  },
  {
    path: '/business/nav-bars',
    redirect: '/business/standard-navigation'
  },
  {
    path: '/business/framework-template',
    redirect: '/business/standard-navigation'
  },
  {
    path: '/business/page-layouts',
    name: 'BusinessPageLayouts',
    component: () => import('../business-views/PageLayoutsView.vue')
  },
  {
    path: '/business/visual-components',
    name: 'BusinessVisualComponents',
    component: () => import('../business-views/VisualComponentsView.vue')
  },
  {
    path: '/business/base-components',
    name: 'BusinessBaseComponents',
    component: () => import('../business-views/BaseComponentsView.vue')
  },
  {
    path: '/business/page-layouts/p/:slug/:variant',
    name: 'BusinessPageLayoutVariant',
    component: () => import('../page-layouts/PageLayoutVariantHost.vue'),
    beforeEnter: (to, _from, next) => {
      if (!['wire', 'real'].includes(to.params.variant)) {
        next({ name: 'BusinessPageLayouts' });
        return;
      }
      next();
    },
  },
  {
    path: '/business/page-layouts/p/:slug',
    redirect: (to) => ({ path: `/business/page-layouts/p/${to.params.slug}/wire` }),
  },
  {
    path: '/components',
    redirect: '/foundation'
  },
  {
    path: '/foundation',
    name: 'Foundation',
    component: () => import('../views/Foundation.vue')
  },
  // 基础规范
  {
    path: '/colors',
    name: 'Colors',
    component: () => import('../views/Colors.vue')
  },
  {
    path: '/typography',
    name: 'Typography',
    component: () => import('../views/Typography.vue')
  },
  // 图标
  {
    path: '/icon',
    name: 'Icon',
    component: () => import('../views/Icon.vue')
  },
  {
    path: '/icon-morph',
    name: 'MorphIcon',
    component: () => import('../views/MorphIcon.vue')
  },
  // 原生 HTML：合并到 EP 页 #native-*；浮层类名单独页
  {
    path: '/native-overlay',
    name: 'NativeOverlay',
    component: () => import('../views/NativeOverlay.vue')
  },
  {
    path: '/button',
    redirect: { path: '/el-button', hash: '#native-button' }
  },
  {
    path: '/select',
    redirect: { path: '/el-select', hash: '#native-select' }
  },
  {
    path: '/checkbox',
    redirect: { path: '/el-checkbox', hash: '#native-checkbox' }
  },
  {
    path: '/radio',
    redirect: { path: '/el-radio', hash: '#native-radio' }
  },
  {
    path: '/switch',
    redirect: { path: '/el-switch', hash: '#native-switch' }
  },
  {
    path: '/dropdown',
    redirect: { path: '/native-overlay', hash: '#native-dropdown' }
  },
  {
    path: '/droplist',
    redirect: { path: '/native-overlay', hash: '#native-droplist' }
  },
  {
    path: '/modal',
    redirect: { path: '/el-dialog', hash: '#native-modal' }
  },
  {
    path: '/tag',
    redirect: '/el-tag'
  },
  {
    path: '/badge',
    redirect: '/el-badge'
  },
  {
    path: '/alert',
    redirect: '/el-alert'
  },
  {
    path: '/form',
    redirect: { path: '/el-form', hash: '#native-form' }
  },
  {
    path: '/input',
    redirect: { path: '/el-input', hash: '#native-input' }
  },
  {
    path: '/table',
    redirect: { path: '/el-table' }
  },
  {
    path: '/pagination',
    redirect: { path: '/el-pagination', hash: '#native-pagination' }
  },
  // Element Plus 组件
  {
    path: '/el-button',
    name: 'ElButton',
    component: () => import('../views/ElButton.vue')
  },
  {
    path: '/el-input',
    name: 'ElInput',
    component: () => import('../views/ElInput.vue')
  },
  {
    path: '/el-select',
    name: 'ElSelect',
    component: () => import('../views/ElSelect.vue')
  },
  {
    path: '/el-table',
    name: 'ElTable',
    component: () => import('../views/ElTable.vue')
  },
  {
    path: '/pm-concrete-loss-tree-table',
    name: 'PmConcreteLossTreeTableDoc',
    component: () => import('../views/PmConcreteLossTreeTableDoc.vue')
  },
  {
    path: '/pm-grey-strip-list',
    name: 'PmGreyStripListDoc',
    component: () => import('../views/PmGreyStripListDoc.vue')
  },
  {
    path: '/el-form',
    name: 'ElForm',
    component: () => import('../views/ElForm.vue')
  },
  {
    path: '/el-dialog',
    name: 'ElDialog',
    component: () => import('../views/ElDialog.vue')
  },
  {
    path: '/el-autocomplete',
    name: 'ElAutocomplete',
    component: () => import('../views/ElAutocomplete.vue')
  },
  {
    path: '/el-cascader',
    name: 'ElCascader',
    component: () => import('../views/ElCascader.vue')
  },
  {
    path: '/el-checkbox',
    name: 'ElCheckbox',
    component: () => import('../views/ElCheckbox.vue')
  },
  {
    path: '/el-date-picker',
    name: 'ElDatePicker',
    component: () => import('../views/ElDatePicker.vue')
  },
  {
    path: '/el-input-number',
    name: 'ElInputNumber',
    component: () => import('../views/ElInputNumber.vue')
  },
  {
    path: '/el-upload',
    name: 'ElUpload',
    component: () => import('../views/ElUpload.vue')
  },
  {
    path: '/el-input-tag',
    name: 'ElInputTag',
    component: () => import('../views/ElInputTag.vue')
  },
  {
    path: '/el-mention',
    name: 'ElMention',
    component: () => import('../views/ElMention.vue')
  },
  {
    path: '/el-radio',
    name: 'ElRadio',
    component: () => import('../views/ElRadio.vue')
  },
  {
    path: '/el-rate',
    name: 'ElRate',
    component: () => import('../views/ElRate.vue')
  },
  {
    path: '/el-slider',
    name: 'ElSlider',
    component: () => import('../views/ElSlider.vue')
  },
  {
    path: '/el-switch',
    name: 'ElSwitch',
    component: () => import('../views/ElSwitch.vue')
  },
  {
    path: '/el-transfer',
    name: 'ElTransfer',
    component: () => import('../views/ElTransfer.vue')
  },
  {
    path: '/el-tag',
    name: 'ElTag',
    component: () => import('../views/ElTag.vue')
  },
  {
    path: '/el-progress',
    name: 'ElProgress',
    component: () => import('../views/ElProgress.vue')
  },
  {
    path: '/el-tree',
    name: 'ElTree',
    component: () => import('../views/ElTree.vue')
  },
  {
    path: '/el-pagination',
    name: 'ElPagination',
    component: () => import('../views/ElPagination.vue')
  },
  {
    path: '/el-badge',
    name: 'ElBadge',
    component: () => import('../views/ElBadge.vue')
  },
  {
    path: '/el-empty',
    name: 'ElEmpty',
    component: () => import('../views/ElEmpty.vue')
  },
  {
    path: '/el-skeleton',
    name: 'ElSkeleton',
    component: () => import('../views/ElSkeleton.vue')
  },
  {
    path: '/el-descriptions',
    name: 'ElDescriptions',
    component: () => import('../views/ElDescriptions.vue')
  },
  {
    path: '/el-result',
    name: 'ElResult',
    component: () => import('../views/ElResult.vue')
  },
  {
    path: '/el-alert',
    name: 'ElAlert',
    component: () => import('../views/ElAlert.vue')
  },
  {
    path: '/el-loading',
    name: 'ElLoading',
    component: () => import('../views/ElLoading.vue')
  },
  {
    path: '/el-message',
    name: 'ElMessage',
    component: () => import('../views/ElMessage.vue')
  },
  {
    path: '/el-message-box',
    name: 'ElMessageBox',
    component: () => import('../views/ElMessageBox.vue')
  },
  // 导航组件
  {
    path: '/el-menu',
    name: 'ElMenu',
    component: () => import('../views/ElMenu.vue')
  },
  {
    path: '/el-tabs',
    name: 'ElTabs',
    component: () => import('../views/ElTabs.vue')
  },
  {
    path: '/pm-segmented-tabs',
    name: 'PmSegmentedTabsDoc',
    component: () => import('../views/PmSegmentedTabsDoc.vue')
  },
  {
    path: '/el-breadcrumb',
    name: 'ElBreadcrumb',
    component: () => import('../views/ElBreadcrumb.vue')
  },
  {
    path: '/el-page-header',
    name: 'ElPageHeader',
    component: () => import('../views/ElPageHeader.vue')
  },
  {
    path: '/el-steps',
    name: 'ElSteps',
    component: () => import('../views/ElSteps.vue')
  },
  // 反馈与展示组件
  {
    path: '/el-tooltip',
    name: 'ElTooltip',
    component: () => import('../views/ElTooltip.vue')
  },
  {
    path: '/el-popover',
    name: 'ElPopover',
    component: () => import('../views/ElPopover.vue')
  },
  {
    path: '/el-popconfirm',
    name: 'ElPopconfirm',
    component: () => import('../views/ElPopconfirm.vue')
  },
  {
    path: '/el-collapse',
    name: 'ElCollapse',
    component: () => import('../views/ElCollapse.vue')
  },
  {
    path: '/el-timeline',
    name: 'ElTimeline',
    component: () => import('../views/ElTimeline.vue')
  },
  {
    path: '/el-divider',
    name: 'ElDivider',
    component: () => import('../views/ElDivider.vue')
  },
  {
    path: '/el-image',
    name: 'ElImage',
    component: () => import('../views/ElImage.vue')
  },
  {
    path: '/el-drawer',
    name: 'ElDrawer',
    component: () => import('../views/ElDrawer.vue')
  },
  // 自定义组件
  {
    path: '/notice-card',
    name: 'NoticeCard',
    component: () => import('../views/NoticeCard.vue')
  },
  {
    path: '/tree-check-list',
    redirect: '/el-tree',
  },
];
